// Supabase request monitor
class SupabaseMonitor {
  private requestLog: Array<{ timestamp: number; type: string; details: string }> = []
  private logRetentionMs = 5 * 60 * 1000 // Keep logs for 5 minutes

  logRequest(type: string, details: string = '') {
    const timestamp = Date.now()
    this.requestLog.push({ timestamp, type, details })

    // Clean up old logs
    this.requestLog = this.requestLog.filter(
      log => timestamp - log.timestamp < this.logRetentionMs
    )

    // console.log(`🔍 SUPABASE MONITOR: ${type} - ${details}`, new Date().toISOString())
    this.printStats()
  }

  getRequestsInLastMinute(): number {
    const oneMinuteAgo = Date.now() - 60 * 1000
    return this.requestLog.filter(log => log.timestamp > oneMinuteAgo).length
  }

  getRequestsInLast5Minutes(): number {
    return this.requestLog.length
  }

  printStats() {
    const lastMinute = this.getRequestsInLastMinute()
    const last5Minutes = this.getRequestsInLast5Minutes()

    // console.log(`📊 SUPABASE STATS: ${lastMinute} requests/min, ${last5Minutes} requests/5min`)

    if (process.env.NODE_ENV === 'development' && lastMinute > 5) {
      console.warn('⚠️ HIGH SUPABASE REQUEST RATE:', lastMinute, 'requests/min')
    }
  }

  getRecentRequests() {
    return this.requestLog.slice(-10) // Last 10 requests
  }
}

export const supabaseMonitor = new SupabaseMonitor()